import EventEmitter from 'events'

class EventBus extends EventEmitter {
  emit (type) {
    console.log('[ EVENT BUS ] Event emitted : ' + type)
    super.emit.apply(this, arguments)
  }
}

export const events = new EventBus()



// WEBPACK FOOTER //
// ./libs/@db2b/keystone/model/utils/event-bus.js